<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The B Word</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<h2 class="h2c"><a id="page_vii"></a>Contents</h2>
<p class="toc-entrya"><a href="#/xhtml/frontmatter01#frontmatter01"><em>Acknowledgments</em></a></p>
<p class="toc-entry"><a href="#/xhtml/frontmatter02#frontmatter02">PROLOGUE   <em>Chasing Amy</em> and Bisexual (In)visibility</a></p>
<p class="toc-entry2"><a href="#/xhtml/frontmatter03#frontmatter03">INTRODUCTION   Binary Trouble and Compulsory Monosexuality</a></p>
<p class="toc-entry1"><span href="#/xhtml/chapter01#chapter01" title="Link target outside of Sample">1   Unthinking Monosexuality: Bisexual<br/>Representability in Art Cinema</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter02#chapter02" title="Link target outside of Sample">2   Power Play/s: Bisexuality as Privilege and Pathology in Sexploitation Cinema</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter03#chapter03" title="Link target outside of Sample">3   Of Cowboys and Cocksmen: Bisexuality and the Contemporary Hollywood Bromance</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter04#chapter04" title="Link target outside of Sample">4   Bisexuality on the Boob Tube</span></p>
<p class="toc-entry3"><span href="#/xhtml/backmatter01#backmatter01" title="Link target outside of Sample">CONCLUSION   Queer/ing Bisexuality</span></p>
<p class="toc-entry2b"><span href="#/xhtml/backmatter02#backmatter02" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc-entry2b"><span href="#/xhtml/backmatter03#backmatter03" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="toc-entry2b"><span href="#/xhtml/backmatter04#backmatter04" title="Link target outside of Sample"><em>Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3c28f3d3